import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  InputAdornment,
} from "@mui/material";
import { styled } from "@mui/system";

const days = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];

const BannerBox = styled(Box)({
  width: "100%",
  height: 150,
  backgroundColor: "#e0e0e0",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "1px dashed #ccc",
  marginTop: 16,
  cursor: "pointer",
});

const CampaignForm = () => {
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        padding: 4,
        backgroundColor: "#fff",
        height: "70vh",
      }}
    >
      <Box sx={{ width: "60%" }}>
        <TextField
          fullWidth
          label="Campaign title"
          variant="outlined"
          margin="normal"
        />
        <TextField
          fullWidth
          label="Campaign Category"
          variant="outlined"
          margin="normal"
        />
        <TextField
          fullWidth
          label="Product Category"
          variant="outlined"
          margin="normal"
        />
        <Box sx={{ display: "flex", gap: 2, marginTop: 2 }}>
          <TextField
            label="Valid Through From"
            type="date"
            InputLabelProps={{ shrink: true }}
            variant="outlined"
            fullWidth
          />
          <TextField
            label="To"
            type="date"
            InputLabelProps={{ shrink: true }}
            variant="outlined"
            fullWidth
          />
        </Box>
        <Box sx={{ marginTop: 2 }}>
          <Typography>Valid on</Typography>
          <Box sx={{ display: "flex", gap: 1, marginTop: 1 }}>
            {days.map((day, index) => (
              <Button
                key={index}
                variant="outlined"
                sx={{
                  minWidth: 36,
                  height: 36,
                  borderRadius: "50%",
                  backgroundColor: day === "Th" || day === "Fr" ? "#2a7374" : "inherit",
                  color: day === "Th" || day === "Fr" ? "#fff" : "inherit",
                }}
              >
                {day}
              </Button>
            ))}
          </Box>
        </Box>
        <TextField
          fullWidth
          label="Total amount"
          variant="outlined"
          margin="normal"
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
          }}
        />
        <TextField
          fullWidth
          label="Offer %"
          variant="outlined"
          margin="normal"
          defaultValue="10%"
        />
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#2a7374",
            marginTop: 2,
            textTransform: "none",
          }}
          fullWidth
        >
          submit now
        </Button>
      </Box>
      <Box sx={{ width: "35%" }}>
        <label htmlFor="file-upload">
          <BannerBox>
            <Typography>
              {selectedFile ? selectedFile.name : "Upload banner here"}
            </Typography>
          </BannerBox>
        </label>
        <input
          id="file-upload"
          type="file"
          style={{ display: "none" }}
          onChange={handleFileUpload}
        />
      </Box>
    </Box>
  );
};

export default CampaignForm;
